import { useCountries } from '../../../hooks';
import { InformedMaterialAutocomplete } from '../InformedMaterialFills';
import LanguageIcon from '@mui/icons-material/Language';

import { Component } from './classes';

// types
import { QuoteComponentProps } from './types';

const QuoteComponent = function ({
  questionInstance,
  classes,
  handleFilesChanged,
  ...props
}: QuoteComponentProps) {
  const countries = useCountries();

  return (
    <InformedMaterialAutocomplete
      label={questionInstance.getQuoteQuestionLabel()}
      name={questionInstance.apiName}
      id={questionInstance.id}
      helperText={questionInstance.helpText}
      required={questionInstance.required}
      className={classes && classes.textfield ? classes.textfield : ''}
      classes={classes}
      {...props}
      variant='standard'
      options={countries
        .map((country) => country.name)
        .sort((a, b) => {
          const priority = ['Canada', 'United States of America'];
          const indexA = priority.indexOf(a);
          const indexB = priority.indexOf(b);
          if (indexA !== -1 || indexB !== -1) {
            return (
              (indexA === -1 ? Infinity : indexA) -
              (indexB === -1 ? Infinity : indexB)
            );
          }
          return 0; // preserve original order otherwise
        })}
      freeSolo={false}
    />
  );
};

const IconComponent = () => {
  return <LanguageIcon fontSize='small' color='primary' />;
};

export function createCountrySelectorComponentRegistry() {
  return new Component({
    type: 'countryDropdown',
    typeLabel: 'Country Selector',
    quoteComponent: QuoteComponent,
    dataType: 'string',
    // programBuilderComponent: ProgramBuilderComponent,
    icon: IconComponent,
  });
}
